import { FC, ReactNode } from 'react';
import classNames from 'classnames';
import Icon, { Sizes } from 'src/common/components/IconDS22';
import getClassNames from 'src/common/utils/getClassNames';
import styles from './InputError.module.scss';

type Props = {
  children: ReactNode;
  preventLayoutShift?: boolean;
  /**
   * Show warning icon next to error message
   */
  showErrorMessageIcon?: boolean;
  position?: 'center';
  iconSize?: Sizes;
  noMargin?: boolean;
};
const InputError: FC<Props> = ({
  children,
  preventLayoutShift = true,
  showErrorMessageIcon = false,
  iconSize = 'm',
  position,
  noMargin = false,
}) => (
  <div className={getClassNames(styles, 'errorWrapper', classNames(position, {
    preventLayoutShift,
    showErrorMessageIcon,
    noMargin,
  }))}
  >
    {showErrorMessageIcon && <Icon id="warning-filled" size={iconSize} className={styles.icon} />}
    <span className={getClassNames(styles, 'error', classNames({ showErrorMessageIcon }))}>{children}</span>
  </div>
);

export default InputError;
